// A small two-tone chip for an interface theme: its surface and its signal
// colour. Used by the Interface pickers (account menu, Settings).
const SkinSwatch = ({ skin }) => (
  <span
    className="sg-skin-swatch"
    aria-hidden="true"
    style={{ "--swatch-surface": skin.swatch[0], "--swatch-signal": skin.swatch[1] }}
  />
);

export default SkinSwatch;
